import { Input, Output, EventEmitter, OnInit, Component } from '@angular/core';
import { FnGridColumn } from './fn-grid-column';
import { FnGridRow } from './fn-grid-row';

@Component({
    template: ''
  })
export abstract class FnGridAbstractCell implements OnInit {
	isDisable: boolean = false;
	ngOnInit(): void {
		if (this.column) {
			this.isDisable = this.column.isEditDisable;
		} else {
			this.isDisable = false;
		}
	}
	@Input() cellValue: any;
	@Input() column: FnGridColumn;
	@Input() row: any|FnGridRow;
	@Input() isEditMode: boolean;

	@Output() public cellClick: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellDoubleClick: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellContextMenu: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellValueChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellBlur: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellFocus: EventEmitter<any> = new EventEmitter<any>();
	@Output() public selectionChange: EventEmitter<any> = new EventEmitter<any>();

	@Output() public cellKeyDown: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellKeyPress: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellMouseOver: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellMouseOut: EventEmitter<any> = new EventEmitter<any>();
	@Output() public cellMouseDown: EventEmitter<any> = new EventEmitter<any>();

	editToggle() {
		this.isEditMode = !this.isEditMode;
	}
	blurAction($evnt?: any) {}
	changeAction($evnt?: any) {}

	dbClickAction() {
		if (!this.isDisable) {
			this.editToggle();
		}
	}
}
